import styled from 'styled-components';

export const Counter = ({ title, points }: CounterProps): JSX.Element => {
	return (
		<>
			<Title>{title}</Title>
			<NumberSpan>{points}</NumberSpan>
		</>
	);
};

type CounterProps = {
	title?: string;
	points?: number;
};

const NumberSpan = styled.span`
	font-size: 48px;
	line-height: 100%;
	color: #f47920;
	margin-bottom: 24px;
	font-weight: bold;
`;

const Title = styled.h2`
	font-size: 24px;
	line-height: 100%;
	margin: 0;
	margin-bottom: 24px;
	color: #575757;
`;
